/**
 *
 * @param {string} a
 * @param {string} b
 */
const stringSorter = (a, b) => {
  if (typeof a !== 'string') {
    return -1;
  }
  if (typeof b !== 'string') {
    return 1;
  }

  return a.localeCompare(b, undefined, { numeric: true });
};

export default stringSorter;
